import {Component, OnInit} from '@angular/core';
import {HomeAllRequestService} from '../service/home-all-request.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {NgxSpinnerService} from 'ngx-spinner';
import {SarService} from '../service/sar.service';
import {AccessService} from '../service/access.service';
import {ModErrorComponent} from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
  // Add 'implements OnInit' to the class.

  request: any[] = [];
  ActiveModule: any;
  id: any;
  hasAgreeed: any;
  order: string;
  baseReq: string;
  pageSize = 5;
  pageNumber = 1;

  constructor(private dataApi: HomeAllRequestService,
              private dataApiR: AccessService,
              private dataSarRefresh: SarService,
              public dialog: MatDialog,
              private spinner: NgxSpinnerService,
              private _snackBar: MatSnackBar) {
    this.dataApi.getHomeRequest()
      .subscribe((data: any) => {
        if(data != null){
          this.request = data.requests;
        }
      });
    this.ActiveModule = {
      admin_rol_list: false,
      admin_types_lists: false,
      admin_business_units: false,
      admin_faq_section: false,
      admin_sites: false,

      // *****check this component */
      pickup_list: false,

      new_access_card: false,
      new_cards_list: false,
      card_reposition: false,
      pickup_cards: false,

      card_approver_list: false,

      access_request_employee: false,
      access_req_exception: false,
      access_req_contractor: false,
      access_list_records: false,
      access_list_approvers: false,
      otherTemporaryAccess: false,

      incoming_access_requests: false,

      policy_form: false,
      policy_check_management: false,
      policy_list: false,

      policy_approver_list: false,

      myAuthorisedAccesses: false,
      myQualifications: false
    };
    this.bodyModules();
    this.order = '&order_by=requestNumber&desc=true';
    this.baseReq = this.order;
  }

  getListEmployeeAccess() {

    if(this.getModulesLength()>0){
      this.spinner.show('loading');
      this.dataApiR
        .getListEmployeeAccess(this.pageNumber, this.pageSize, false, this.baseReq, true, false)
        .subscribe((data: any) => {
          if (data.items === null || data.items === undefined) {
            this.request = [];
          } else {
            this.request = data.items;
            this.pageNumber = data.paginator.page;
            this.pageSize = data.paginator.limit;
          }
          this.spinner.hide('loading');
        }, (err) => {
          this.spinner.hide('loading');
          if(err.error.error !== 'Invalid token.') {
            this.dialog.open(ModErrorComponent, {
              width: 'auto',
              panelClass: 'myapp-no-padding-dialog',
            });
          }
        });
    }

  }

  getModulesLength(){
    if (sessionStorage.currentUser){
      return JSON.parse(sessionStorage.currentUser).modules.length;
    }
    return 0;
  }

  bodyModules() {
    for (const idmod of JSON.parse(sessionStorage.currentUser).modules) {

      switch (Number(idmod)) {
        case 1:
          this.ActiveModule.admin_rol_list = false;
          break;
        case 2:
          this.ActiveModule.admin_types_lists = false;
          break;
        case 3:
          this.ActiveModule.admin_business_units = false;
          break;
        case 4:
          this.ActiveModule.admin_faq_section = false;
          break;
        case 6:
          this.ActiveModule.admin_sites = false;
          break;
        case 11:
          this.ActiveModule.pickup_list = true;
          break;
        case 12:
          this.ActiveModule.new_access_card = true;
          break;
        case 14:
          this.ActiveModule.new_cards_list = true;
          break;
        case 16:
          this.ActiveModule.card_reposition = true;
          break;
        case 17:
          this.ActiveModule.pickup_cards = true;
          break;
        case 18:
          this.ActiveModule.card_approver_list = true;
          break;
        case 20:
          this.ActiveModule.access_request_employee = true;
          break;
        case 22:
          this.ActiveModule.access_req_exception = true;
          break;
        case 23:
          this.ActiveModule.access_req_contractor = true;
          break;
        case 24:
          this.ActiveModule.access_list_records = true;
          break;
        case 26:
          this.ActiveModule.access_list_approvers = true;
          break;
        case 27:
          this.ActiveModule.incoming_access_requests = true;
          break;
        case 30:
          this.ActiveModule.policy_form = true;
          break;
        case 32:
          this.ActiveModule.policy_check_management = true;
          break;
        case 33:
          this.ActiveModule.policy_list = true;
          break;
        case 34:
          this.ActiveModule.policy_approver_list = true;
          break;
        case 36:
          this.ActiveModule.otherTemporaryAccess = true;
          break;
        case 37:
          this.ActiveModule.myAuthorisedAccesses = true;
          break;
        case 39:
          this.ActiveModule.myQualifications = true;
          break;
      }
    }
  }

  ngOnInit() {
    this.getListEmployeeAccess();
  }
}
